import React from 'react'
import PendingForm from './components/PenddingForm'

const index = () => {
  return (
   <>
   <PendingForm/>
   </>
  )
}

export default index